module.exports = __webpack_public_path__ + "static/img/brees-2010-top-image.36cf9fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2010-top-image.jpg
// module id = pVNB
// module chunks = 1